<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Default</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <carousel :perPageCustom="[[480, 1], [768, 1]]" :paginationEnabled="false">
              <slide data-index="0" data-name="MySlideName">
                <img class="w-full" src="@/assets/images/card2.png" />
              </slide>
              <slide data-index="0" data-name="MySlideName">
                <img class="w-full" src="@/assets/images/card.png" />
              </slide>
             
            </carousel>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Navigation</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <carousel :per-page="1" >
              <slide data-index="0" data-name="MySlideName">
                <img class="w-full" src="@/assets/images/blog1.jpg" />
              </slide>
              <slide data-index="0" data-name="MySlideName">
                <img class="w-full" src="@/assets/images/blog2.jpg" />
              </slide>
              <slide data-index="0" data-name="MySlideName">
                <img class="w-full" src="@/assets/images/blog3.jpg" />
              </slide>
            </carousel>
          </div>
        </div>
      </vs-col>
      
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({ colorx: "#c72a75", colorx2: "#5252e8" }),
};
</script>